import { createSelector } from 'reselect';
import { ContactContainerProps } from './ContactTypes';
import { ContactState } from '../../reduxTypes';

const getContactStore = (state, _): ContactState => state.contactStore;

const getContactId = (_, props: ContactContainerProps): number => props.contactId;

export const getContactData = createSelector(
    [getContactStore, getContactId],
    (contactStore, contactId) => {
        const loadedContact = contactStore.contact.filter(({ id }) => id === contactId);

        if (loadedContact && loadedContact.length) {
            return loadedContact[0];
        }
    }
);




// WEBPACK FOOTER //
// ./src/sections/Contact/ContactSelector.ts